import React, { Component } from 'react'

class LoadingScreen extends Component {
	render() {
		return (
			<div id='loading-screen'>
				<h1>{this.props.title}</h1>
			</div>
		)
	}
}

export default LoadingScreen
